import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import AximDropdown from "components/Dropdown/AximDropdown";
import { Box } from "@mui/material";
import { apiGet } from "app/Services/ApiService";
import { Utils } from "common/Utils";
import { employeeApiUrls } from "common/ApiUrls";
import LoaderAnimation from "pages/LoaderAnimation";
import TableStyle from "components/Content/Table/TableStyle.module.css";

import moment from "moment";

export default function TimeSheet() {
    const [payDatesDropdown, setPayDatesDropdown] = useState([]);
    const [payDateSelected, setPayDateSelected] = useState("");
    const [timeSheets, setTimeSheets] = useState(null);
    const [hasInitializationError, setHasInitializationError] = useState(false);

    let { payPeriod } = useParams();

    useEffect(() => {
        apiGet(employeeApiUrls.getTimeSheets).then((response) => {
            let payDates = response.data.map(d => d.payDate);

            setPayDatesDropdown(payDates);

            setTimeSheets(response.data);
        })
        .catch(e => {
            console.log(e);
            setHasInitializationError(true);
        });
    },[payPeriod])

    useEffect(() => {
        if (payDatesDropdown.length > 0) {
            var found = payDatesDropdown.find(e => Utils.formatDate(e) === Utils.formatDate(payPeriod));

            if (found) {
                setPayDateSelected(found);
            }
            else {
                setPayDateSelected(payDatesDropdown[0]);
            }
        }
    },[payDatesDropdown])

    return (
        <Box className={TableStyle.tableWrapper}>
            {hasInitializationError ? <h4>Error Loading Time Sheets</h4> :
            timeSheets === null ? <LoaderAnimation /> :
            timeSheets.length === 0 ? <h5 className="text-center mb-4">No Time Sheets to display</h5> :
                <Box className="container-fluid">
                    <Box className="d-flex justify-content-start">
                        {payDatesDropdown.length > 0 ? (
                        <AximDropdown
                            label="Pay Dates"
                            handleChange={(e) => setPayDateSelected(e.target.value)}
                            value={payDateSelected}
                            pairs={payDatesDropdown.map(payDates => ({ value: payDates, text: moment(payDates).format("MMMM DD, YYYY") }))} />
                        ) : (
                        ""
                        )}
                    </Box>
                    <Box className="row justify-content-center">
                        {timeSheets.length > 0 && (
                            timeSheets.map((timeSheet, index) => {
                                if (payDateSelected !== null && payDateSelected !== timeSheet.payDate) {
                                    return null;
                                }

                                let contractHours = timeSheet.payPeriodHours.filter(a => a.isContract == 1).map(a => a.hours).reduce((a,b) => a + b, 0);

                                return (
                                    <Box className="col-12 col-md-7 row mb-5" key={index}>
                                        <Box className="row col-12">
                                            <Box className="col-12 border py-2" sx={{backgroundColor: 'primary.veryLight'}}>
                                                <h5>
                                                    <strong>
                                                        {`Pay Period: ${moment(timeSheet.workStart).format("MMMM DD, YYYY")} To ${moment(timeSheet.workEnd).format("MMMM DD, YYYY")}`}
                                                    </strong>
                                                </h5>
                                            </Box>
                                        </Box>
                                        {timeSheet.payPeriodHours.map((hours, index) =>
                                            <Box className="row col-12">
                                                <Box className="col-8 border">{hours.hoursTypeName}</Box>
                                                <Box className="col-4 border text-end">{hours.hours.toFixed(2)}</Box>
                                            </Box>
                                        )}
                                        <Box className="row col-12 mb-2">
                                            <Box className="col-8 border"><strong>Total Contract Hours</strong></Box>
                                            <Box className="col-4 border text-end">
                                                <strong>{contractHours.toFixed(2)}</strong>
                                            </Box>
                                        </Box>

                                        <Box className="row col-12">
                                            <Box className="col-8 border"><strong>Total Pay Period Hours</strong></Box>
                                            <Box className="col-4 border text-end">
                                                <strong>{contractHours.toFixed(2)}</strong>
                                            </Box>
                                        </Box>
                                    </Box>)
                            })
                        )}
                    </Box>
                </Box>
            }
        </Box>
    )
}
